import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../api";
import { useAuth } from "../auth";
import { errorText } from "../hooks";

export function ChangePasswordPage() {
  const { user, refresh } = useAuth();
  const nav = useNavigate();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [again, setAgain] = useState("");
  const [error, setError] = useState<string | null>(null);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (next !== again) return setError("The new passwords differ.");
    try {
      await api.changePassword(current, next);
      await refresh();
      nav("/");
    } catch (err) {
      setError(errorText(err));
    }
  };

  return (
    <div className="card" style={{ maxWidth: 420 }}>
      <h1>Change password</h1>
      {user?.must_change_password && <p className="muted">Choose your own password before continuing.</p>}
      <form onSubmit={submit} style={{ display: "grid", gap: "0.8rem" }}>
        <label>Current password<input type="password" autoComplete="current-password" value={current} onChange={(e) => setCurrent(e.target.value)} /></label>
        <label>New password (12+ characters)<input type="password" autoComplete="new-password" value={next} onChange={(e) => setNext(e.target.value)} /></label>
        <label>New password again<input type="password" autoComplete="new-password" value={again} onChange={(e) => setAgain(e.target.value)} /></label>
        {error && <div className="error">{error}</div>}
        <button disabled={!current || next.length < 12}>Save</button>
      </form>
    </div>
  );
}
